import { useSmartQuery, useSmartMutation } from "@shared/api/queries/hooks";
import { downloadFile, openPdfInNewTab } from "@shared/utils/utils";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { billTemplateV3Api } from "./api";

export function useAccountTypeChoices() {
  const remoteUtilityId = getRemoteUtilityId();
  return useSmartQuery(
    ["bx", "billTemplateV3", "choices", "account-type",remoteUtilityId],
    () => billTemplateV3Api.getAccountTypeChoices(remoteUtilityId)
  );
}

export function useDashboardCards(filters?: { search?: string; accountType?: string; status?: string }) {
  const remoteUtilityId = getRemoteUtilityId();

  return useSmartQuery(
    ["bx", "billTemplateV3", "dashboardCards", remoteUtilityId, filters],
    () => billTemplateV3Api.getDashboardCards(remoteUtilityId, filters),
    {
      enabled: !!remoteUtilityId,
    }
  );
}

export function useTemplateSummary() {
  const remoteUtilityId = getRemoteUtilityId();

  return useSmartQuery(
    ["bx", "billTemplateV3", "templateSummary", remoteUtilityId],
    () => billTemplateV3Api.getTemplateSummary(remoteUtilityId),
    {
      enabled: !!remoteUtilityId,
    }
  );
}

export function useUtilityPlans() {
  const remoteUtilityId = getRemoteUtilityId();

  return useSmartQuery(
    ["bx", "billTemplateV3", "utilityPlans", remoteUtilityId],
    () => billTemplateV3Api.getUtilityPlans(remoteUtilityId),
    {
      enabled: !!remoteUtilityId,
    }
  );
}

export function useReceiptPreview(templateId:string,planId?: string | number, cardType?: string) {
  const remoteUtilityId = getRemoteUtilityId();

  const isMaster = cardType?.toLowerCase() === 'master';

  return useSmartQuery(
    ["bx", "billTemplateV3", "receiptPreview", templateId, planId, remoteUtilityId, cardType],
    () => billTemplateV3Api.getReceiptPreview(templateId, planId, remoteUtilityId, false, cardType),
    {
      enabled: !!remoteUtilityId && (isMaster || !!planId),
    }
  );
}

export function useReceiptDownload() {
  const remoteUtilityId = getRemoteUtilityId();

  return useSmartMutation(
    async ({
      templateId,
      planId,
      cardType,
      filename = "receipt.pdf",
    }: {
      templateId: string;
      planId?: string | number;
      cardType?: string;
      filename?: string;
    }) => {
      const blob = await billTemplateV3Api.getReceiptPreview(
        templateId,
        planId,
        remoteUtilityId,
        true,
        cardType
      );
      downloadFile(blob, filename);
      return blob;
    }
  );
}

export function useReceiptPrint() {
  const remoteUtilityId = getRemoteUtilityId();

  return useSmartMutation(
    async ({
      templateId,
      planId,
      cardType,
    }: {
      templateId: string;
      planId?: string | number;
      cardType?: string;
    }) => {
      const blob = await billTemplateV3Api.getReceiptPreview(
        templateId,
        planId,
        remoteUtilityId,
        true,
        cardType
      );
      openPdfInNewTab(blob);
      return blob;
    }
  );
}
